define('lib/Podio.UI.PeoplePicker',['require','underscore','jquery','translate','lib/Podio.Transport','lib/Podio.Routes','jst!people_picker/_wrapper','lib/backbone/Backbone.Mixins.Transport.API','lib/view_helpers/base','lib/Podio.Utils.Text','controllers/peoplefinder/Podio.Controllers.PeopleFinder.Main'],function(require) {

  var _ = require('underscore');
  var $ = require('jquery');
  var t = require('translate');
  var transport = require('lib/Podio.Transport');
  var routes = require('lib/Podio.Routes');
  var jstWrapper = require('jst!people_picker/_wrapper');
  var APITransport = require('lib/backbone/Backbone.Mixins.Transport.API');
  var viewHelpers = require('lib/view_helpers/base');
  var textUtils = require('lib/Podio.Utils.Text');

  var defaultOptions = {
    limit: 12,
    disablePeoplePicker: false,
    podioPickerOptions: {
      initialFocusInInput: false,
      allowFreeTokens: true,
      freeTokenMode: 'email',
      inputTokenIcon: 'icon-user',
      classes: { tokenList: 'token-input-list fluid people-picker' },
      placeholderText: t('Pick a connection or type an email address #contact_app_type')
    },
    useDirectAPIAccess: false,
    templates: {
      wrapper: jstWrapper
    },
    peopleFinderConfig: null
  };

  var PeoplePicker = function(elmInput, target, options) {
    this.options = options ? $.extend(true, {}, defaultOptions, options) : defaultOptions;
    this.templates = this.options.templates;
    this.elmInput = elmInput;
    this.configTarget = target;

    this.initialize.apply(this, arguments);
    return this;
  };

  _.extend(PeoplePicker.prototype, {

    initialize : function() {
      _.bindAll(this, 'getPickerData', 'prePopulateData', 'mapItem', 'onBeforePickerEmailAdded', 'onPeopleFinderButtonClicked', 'onPeopleFinderSubmit', 'itemsForFinder', 'itemsFromFinder', 'onPickerCustomItemSelected');
      this.validateOptions();
      this.initElements();
      this.delegateEvents();
    },

    validateOptions : function() {
      if (!this.elmInput) {
        throw 'No input element passed';
      }

      // See https://developers.podio.com/doc/reference/search-references-13312595
      if (!this.configTarget) {
        throw 'Must pass in target, must be one of [task_responsible, share]';
      }
    },

    initElements : function() {
      var self = this;

      // Copy attributes from existing input and replace it with people finder markup
      this.elmWrapper = $(this.templates.wrapper({
        enablePeoplePicker: !this.options.disablePeoplePicker,
        tracking: this.options.tracking
      }));

      var templateInput = this.elmWrapper.find('input');

      //_.each(['id', 'name', 'size', 'tabindex'], function(name) {
      //  templateInput.attr(name, self.elmInput.attr(name));
      //});
      _.each(this.elmInput[0].attributes, function(attr) {
        if (attr.nodeName !== 'type') {
          templateInput.attr(attr.nodeName, attr.value);
        }
      });

      this.elmInput.replaceWith(this.elmWrapper);
      this.elmInput = templateInput;

      // Podio picker
      var pickerOptions = $.extend(true, {}, this.options.podioPickerOptions, {
        onDataRequest: this.getPickerData,
        prePopulate: this.prePopulateData(),
        onFreeTokenAdded: this.onBeforePickerEmailAdded
      });

      this.elmInput.podioPicker(pickerOptions);

      // People Finder button
      this.elmFinderButton = this.elmWrapper.find('.activate-people-finder');
    },

    delegateEvents : function() {
      this.elmFinderButton.on('click', this.onPeopleFinderButtonClicked);
      this.elmInput.on('podioPicker.customOption', this.onPickerCustomItemSelected);
    },

    onPeopleFinderDone: function(data) {
      this.onPeopleFinderSubmit( data.toJSON() );
      this.elmInput.trigger('peoplePicker:peopleFinderFinished');
      this.disposePeopleFinder();
    },

    disposePeopleFinder: function() {
      this.peopleFinder.signals.onDone.remove(this.onPeopleFinderDone);
      this.peopleFinder.signals.onClose.remove(this.disposePeopleFinder);
      this.peopleFinder.destroy();
      delete this.peopleFinder;
    },

    showPeopleFinder: function() {
      this.libPeopleFinder = require('controllers/peoplefinder/Podio.Controllers.PeopleFinder.Main');
      var peopleFinderConfig = this.options.peopleFinderConfig || this.getPeopleFinderConfig();
      this.peopleFinder = new this.libPeopleFinder(peopleFinderConfig);

      this.elmInput.trigger('hideAutocompleter.picker.podio');
      var items = this.itemsForFinder(this.elmInput.data('tokens'));

      this.peopleFinder.populate(items);
      this.peopleFinder.show();

      this.peopleFinder.signals.onDone.add(this.onPeopleFinderDone, this);
      this.peopleFinder.signals.onClose.add(this.disposePeopleFinder, this);
    },

    addCustomOptions : function(items) {

      var option = {
        name : t("Can't find who you are looking for? Assign task to people outside this workspace #peoplepicker"),
        id: 'assign',
        custom: true,
        itemIcon: 'icon-16 icon-message'
      };

      // if not already on the list
      if ( ! _.include(_.pluck(items, 'id'), 'assign') ) {
        items.push(option);
      }

      return items;
    },

    getPickerData : function(mode, query, callback) {
      var storeKey = 'autcomplete_people_picker_' + this.getTarget();
      var querystring = { 'target': this.getTarget(), 'query': query };

      var targetParams = {};

      if (this.options.referenceSearchTargetParams) {
        $.extend(querystring, this.options.referenceSearchTargetParams);
        _.each(this.options.referenceSearchTargetParams, function(value, key) {
          storeKey += key + '_' + value;
          targetParams[key] = value;
        });
      } else if (this.getTarget() === 'item_field') {
        var elmField = this.elmInput.parents('.field:first');
        var fieldId = elmField.data('app-field-id');
        querystring['field_id'] = fieldId;
        storeKey += '_' + fieldId;

        targetParams['field_id'] = fieldId;
      }

      var reqUrl = routes.autocomplete_reference_picker_path(querystring);
      var req = transport.cachedRequest('get', 'json', reqUrl, {
        abortable   : true,
        storeKey    : storeKey,
        requestKey  : 'search_{0}'.format( query ),
        requestData : {}
      });

      var self = this;

      if (this.options.useDirectAPIAccess) {
        var requestData = {
          target: this.getTarget(),
          text: query,
          limit: 12,
          target_params: targetParams
        };

        APITransport.request('POST', '/reference/search', requestData).done(function(responseData) {
          var itemsCopy = $.extend(true, [], self.referenceSearchToPickerFormat(responseData)); // Picker modifies collection

          callback.apply( this, [itemsCopy] );
        });
      } else {
        req.done(function(responseData) {
          var items = [];
          if ( responseData.status === 'ok' ) {
            items = responseData.data.items;

            if ( !self.options.disablePeoplePicker && self.getTarget() === 'task_responsible' ) {
              items = self.addCustomOptions(items);
            }

            _.each(items, function(group) {
              _.each(group.items, function(item, index) {
                group[index] = self.mapItem(item);
              });
            });
          }
          var itemsCopy = $.extend(true, [], items); // Picker modifies collection
          callback.apply( this, [itemsCopy] );
        });
      }

    },

    referenceSearchToPickerFormat: function(responseData, options) {
      options = options || {};
      return _.map(responseData, function(group) {

        if (options.useProfileIdForMembers && (group.name === 'space_members' || group.name === 'profiles')) {
          group.name = 'space_members_using_profile_id';
        }

        var items = this.pickerGroup(group);
        if (!options.noMapping) {
          items = _.map(items, this.mapItem);
        }

        return {
          'id': group.name === 'app' ? group.data.app_id : group.name,
          'type': 'group',
          'name': this.pickerGroupName(group),
          'items': items
        };
      }, this);
    },

    pickerGroup: function(group) {
      switch (group.name) {
      case 'profiles':
      case 'space_members':
      case 'created_by_user':

          // TODO: If target is item_field_filter profile_id should be used as identifier
          //       Only used for item filters
          // TODO: Conversations uses a different avatar size.

        return _.map(group.contents, function(item) {
          return {
            id: item.user_id,
            name: item.name,
            ref_type: 'user',
            type: 'user',
            itemIcon: viewHelpers.avatar_url_for(item, 'tiny'),
            image: item.image,
            link: item.link
          };
        }, this);
      case 'space_contacts':
      case 'space_members_using_profile_id':
        return _.map(group.contents, function(item) {
          return {
            id: item.profile_id,
            name: item.name,
            ref_type: 'profile',
            type: 'profile',
            itemIcon: viewHelpers.avatar_url_for(item, 'tiny'),
            image: item.image,
            link: item.link
          };
        }, this);
      case 'spaces':
        return _.map(group.contents, function(item) {
          var suffix = item.member_count ? '({0})'.format(item.member_count) : null;

          return {
            id: item.space_id,
            name: item.name,
            ref_type: 'space',
            type: 'space',
            itemIcon: 'icon-16 icon-space',
            link: item.url,
            info: item.org.name,
            suffix: suffix,
          };
        }, this);
      case 'apps':
        return _.map(group.contents, function(item) {
          return {
            id: item.app_id,
            name: item.config.name,
            ref_type: 'app',
            type: 'app',
            itemIcon: 'app-icon-16 icon-{0}'.format(item.config.icon_id),
            link: item.link,
            info: '{0} - {1}'.format(item.space.name, item.space.org.name)
          };
        }, this);
      default:
        throw new Error('Picker cannot format this group type.');
      }
    },

    pickerGroupName: function(group) {
      switch (group.name) {
      case 'spaces':
        return t('Workspaces #tasks');
      case 'apps':
        return t('Apps #autocomplete.group');
      case 'app':
        return group.data.config.name;
      case 'profiles':
        return t('People #autocomplete.group');
      case 'created_by_user':
        return t('People #autocomplete.group');
      case 'created_by_app':
        return t('Apps #autocomplete.group');
      case 'space_members':
      case 'space_members_using_profile_id':
        return t('Members #autocomplete.group');
      case 'space_contacts':
        return t('Contacts #autocomplete.group');
      case 'tags':
        return t('Tags #autocomplete.group');
      case 'tasks':
        return t('Tasks #autocomplete.group');
      case 'auth_clients':
        return t('Via #autocomplete.group');
      default:
        return '';
      }
    },

    prePopulateData : function() {
      var items = this.options.prePopulate;
      if (items && items.length) {
        var self = this;
        _.each(items, function(item, index) {
          items[index] = self.mapItem(item);
        });
      }
      return items;
    },

    // Changes the id if the item to include the ref type of the item
    mapItem : function(item) {
      if (!item.mapped) {
        if (item.ref_type === 'external') {
          item.id = item.ref_type + '|' + item.linked_account_id + '|' + item.external_contact_id;
        } else {
          item.id = item.ref_type + '|' + item.id;
        }
        item.mapped = true;
      }
      return item;
    },

    // Translates tokens from PodioPicker format to PeopleFinder format
    // Format: { ref_type, id, name, itemIcon }
    // ref_type external has linked_account_id and external_contact_id instead of just id
    itemsForFinder : function(pickerItems) {
      var finderItems = {
        user: [],
        space: [],
        mail: [],
        profile: [],
        external: []
      };

      _.each(pickerItems, function(pickerItem) {
        if (!_.isFunction(pickerItem)) {
          var finderItem = $.extend(true, {}, pickerItem);
          var idParts = pickerItem.id.split('|');
          finderItem.ref_type = idParts[0];
          if (finderItem.ref_type === 'external') {
            finderItem.id = idParts[2];
            finderItem.linked_account_id = parseInt(idParts[1], 10);
            finderItem.external_contact_id = idParts[2];
          } else {
            finderItem.id = _.isNaN(parseInt(idParts[1],10) ) ? idParts[1] : parseInt(idParts[1], 10);
          }
          finderItem.mapped = false;
          finderItems[finderItem.ref_type].push(finderItem);
        }
      });

      return finderItems;
    },

    // Translates items from PeopleFinder format to PodioPicker tokens
    itemsFromFinder : function(finderItems) {
      var self = this;
      var pickerItems = [];
      _.each(['user', 'space', 'mail', 'profile', 'external'], function(refType) {
        var typeItems = finderItems[refType];
        if (typeItems && typeItems.length) {
          _.each(typeItems, function(finderItem) {
            var pickerItem = $.extend(true, {}, finderItem);
            pickerItem.ref_type = refType;
            pickerItem = self.mapItem(pickerItem);
            pickerItems.push(pickerItem);
          });
        }
      });

      return pickerItems;
    },

    // Prepares data to be submitted directly to the API, split into
    // users, profiles, mails and external_contract as according to
    // https://podio.com/podio/api/apps/api-operations/items/386
    apiFriendlyValues : function(rawValue) {
      var friendly = { mails: [], users: [], profiles: [], external_contacts: {} };
      rawValue = rawValue || this.elmInput.val();
      if (rawValue) {
        var tokens = rawValue.split(',');
        _.each(tokens, function(token) {
          var parts = token.split('|');
          switch (parts.length) {
          case 1:
            friendly.users.push(parseInt(parts[0], 10)); // No type, assume user id
            break;
          case 2: // Regular mail, user or profile, with type given
            var type = parts[0];
            var id = parts[1];
            if (type === 'mail') { // Change ids to integers, except for mails
              if (! textUtils.isValidEmail(id)) {
                break;
              }
            } else {
              id = parseInt(id, 10);
            }

            friendly[type + 's'].push(id); // Type is singular, add "s" for collection
            break;
          case 3: // Three parts, assume external
            var linkedAccountId = parseInt(parts[1], 10);
            var externalContactId = parts[2];
            friendly.external_contacts[linkedAccountId] = friendly.external_contacts[linkedAccountId] || [];
            friendly.external_contacts[linkedAccountId].push(externalContactId);
            break;
          }
        });
      }
      return friendly;
    },

    onBeforePickerEmailAdded : function(email) {
      return {
        id: 'mail|' + email,
        name: email
      };
    },

    onPickerCustomItemSelected: function(e, eventData) {
      var self = this;

      _.defer(function() {
        if (eventData.item.id === 'assign') {
          self.showPeopleFinder();
        }
      });
    },

    onPeopleFinderButtonClicked : function(e) {
      this.showPeopleFinder();
    },

    onPeopleFinderSubmit : function(finderItems) {
      var items = this.itemsFromFinder(finderItems);
      this.elmInput.trigger('populate.picker.podio', [items]);
    },

    getTarget: function() {
      if (this.configTarget.match(/contact_field/)) {
        return 'item_field';
      } else {
        return this.configTarget;
      }
    },

    getPeopleFinderConfig: function() {

      var config = {
        'task_responsible': [
          {type: 'podio', visible: true, order: 'task'},
          {type: 'mail', visible: true},
          {type: 'linkedAccounts', visible: true, contactable: true}
        ],
        'grant': [
          {type: 'podio', visible: true, excludeSelf: true, order: 'grant'},
          {type: 'mail', visible: true},
          {type: 'linkedAccounts', visible: true, contactable: true}
        ],
        'conversation': [
          {type: 'podio', visible: true, excludeSelf: true, order: 'message'},
          {type: 'mail', visible: true},
          {type: 'linkedAccounts', visible: true, contactable: true}
        ],
        'invite': [
          {type: 'podio', visible: true, excludeSelf: true, order: 'total'},
          {type: 'mail', visible: true},
          {type: 'linkedAccounts', visible: true, contactable: true}
        ],

        // Sane naming for apps_items_v2 contact fields.
        // Re-uses the string from app field config settings
        'contact_field_space_users': [
          {type: 'podioSpaceMembers', visible: true, spaceId: this.options.spaceId, order: 'contact'}
        ],
        'contact_field_all_users': [
          {type: 'podio', visible: true, order: 'contact'},
          {type: 'mail', visible: true},
          {type: 'linkedAccounts', visible: true, contactable: true}
        ],
        'contact_field_space_contacts': [
          {type: 'podioSpaceContacts', visible: true, spaceId: this.options.spaceId, order: 'contact'},
          {type: 'linkedAccounts', visible: true, contactable: false}
        ],
        'contact_field_space_users_and_contacts': [
          {type: 'podioSpaceMembers', visible: true, spaceId: this.options.spaceId, order: 'contact'},
          {type: 'podioSpaceContacts', visible: true, spaceId: this.options.spaceId},
          {type: 'linkedAccounts', visible: true, contactable: false}
        ],

        // Totally arbitrary naming used for legacy contact app fields.
        'contact_field_workspace_users': [
          {type: 'podioSpaceMembers', visible: true, spaceId: this.options.spaceId, order: 'contact'}
        ],
        'contact_field_users_share': [
          {type: 'podio', visible: true, order: 'contact'},
          {type: 'mail', visible: true},
          {type: 'linkedAccounts', visible: true, contactable: true}
        ],
        'contact_field_workspace_contacts': [
          {type: 'podioSpaceContacts', visible: true, spaceId: this.options.spaceId, order: 'contact'},
          {type: 'linkedAccounts', visible: true, contactable: false}
        ],
        'contact_field_space_members_and_contacts': [
          {type: 'podioSpaceMembers', visible: true, spaceId: this.options.spaceId, order: 'contact'},
          {type: 'podioSpaceContacts', visible: true, spaceId: this.options.spaceId, order: 'contact'},
          {type: 'linkedAccounts', visible: true, contactable: false}
        ],

      };

      return config[this.configTarget];
    }
  });

  return PeoplePicker;

});

